var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'core', 'collection/base', 'model/ledger-account'], function($, _, core, BaseCollection, LedgerAccountModel) {
  var LedgerAccountCollection;
  return LedgerAccountCollection = (function(_super) {

    __extends(LedgerAccountCollection, _super);

    function LedgerAccountCollection() {
      LedgerAccountCollection.__super__.constructor.apply(this, arguments);
    }

    LedgerAccountCollection.prototype.initialize = function(models, options) {
      if (options == null) {
        options = {};
      }
      return this.clientId = options.clientId ? options.clientId : core.getCurrentClientId();
    };

    LedgerAccountCollection.prototype.path = function() {
      return core.getConfig().apiPrefix + 'ledgeraccount.json/client/' + this.clientId;
    };

    LedgerAccountCollection.prototype.model = LedgerAccountModel;

    return LedgerAccountCollection;

  })(BaseCollection);
});
